export const getCurrentVisitorPermitDetails = (state) =>
  state.CurrentVisitorPermitDetails;
export const getQuickPermitSetupDetailForProperty = (state) =>
  state.CurrentVisitorPermitDetails.QuickPermitSetupDetail;
